var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h64v64H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FC6666",
    cx: 32,
    cy: 32,
    r: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 27.787l10.859-10.862c2.81-2.808 7.024 1.406 4.213 4.214L34.107 34.107a2.979 2.979 0 01-4.214 0L16.925 21.14c-2.808-2.81 1.406-7.024 4.214-4.213L32 27.787zm0 8.426L21.141 47.075c-2.81 2.808-7.024-1.406-4.213-4.214l12.965-12.968a2.979 2.979 0 014.214 0L47.075 42.86c2.808 2.81-1.406 7.024-4.214 4.213L32 36.213z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA2NCA2NCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0wIDBoNjR2NjRIMHoiLz48Y2lyY2xlIGZpbGw9IiNGQzY2NjYiIGN4PSIzMiIgY3k9IjMyIiByPSIzMiIvPjxwYXRoIGQ9Ik0zMiAyNy43ODdsMTAuODU5LTEwLjg2MmMyLjgxLTIuODA4IDcuMDI0IDEuNDA2IDQuMjEzIDQuMjE0TDM0LjEwNyAzNC4xMDdhMi45NzkgMi45NzkgMCAwIDEtNC4yMTQgMEwxNi45MjUgMjEuMTRjLTIuODA4LTIuODEgMS40MDYtNy4wMjQgNC4yMTQtNC4yMTNMMzIgMjcuNzg3em0wIDguNDI2TDIxLjE0MSA0Ny4wNzVjLTIuODEgMi44MDgtNy4wMjQtMS40MDYtNC4yMTMtNC4yMTRsMTIuOTY1LTEyLjk2OGEyLjk3OSAyLjk3OSAwIDAgMSA0LjIxNCAwTDQ3LjA3NSA0Mi44NmMyLjgwOCAyLjgxLTEuNDA2IDcuMDI0LTQuMjE0IDQuMjEzTDMyIDM2LjIxM3oiIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0ibm9uemVybyIvPjwvZz48L3N2Zz4=";
export { SvgError as ReactComponent };